import React, {PureComponent} from 'react';
import Header from './header';
import LeftSide from './left_side';
import RightSide from './right_side';
import _ from 'lodash';
import Constants from './../constants';

class Dashboard extends PureComponent {
	constructor(props, state) {
		super(props, state);
		this.handleSelectApp = this.handleSelectApp.bind(this);
		this.state = {
			selected: {},
			results: [],
			orgs: [],
			app: {},
			newApp: false
		};
	};
	createNewApp() {
		this.setState({newApp: true});
	};
	setFalseNewApp() {
		this.setState({newApp: false});
	};
	getServers = () => {
		return fetch(Constants.SERVER_PATH + `organization`)
			.then((resp) => {
				return resp.json();
			})
			.then((json) => {
				let res = _.sortBy(json.result, 'name');
				res.unshift({id: -1, name: 'Без организации'});
				//getServersValue(res);
				this.setState({orgs: res});
				return {options: res};
			})
			.catch((error) => {
				console.info('getServers Error: ' + error);
			})
	};
    catchHandler = err => {
        console.info('apps onChange Error from catchHandler: ' + err);
    };
	onChange = selected => {
		this.setState({selected: selected ? selected : 'try'});
		if(selected && selected.id/* > 0*/) {
			return fetch(Constants.SERVER_PATH + `apps?&org=${selected.id}`)
				.then(resp => {
					return resp.json();
				})
				.then(json => {
					this.setState({
						results: json.result
					});
				})
				.catch(error => {
					console.info('apps?&org Error: ' + error);
				});
		} else {
			return fetch(Constants.SERVER_PATH + `apps`)
				.then(resp => {
					return resp.json();
				})
				.then(json => {
					this.setState({
						results: json.result
					})
				})
				.catch(error => {
					console.info('apps onChange Error: ' + error);
					this.catchHandler(error);
				});
		}
	};
	handleSelectApp(result) {
		fetch(Constants.SERVER_PATH + `app/${result.id || result.description}`)
			.then((resp) => {
				return resp.json();
			})
			.then((json) => {
				this.setState({
					app: json.result
				});
			})
			.catch((error) => {
				console.info('apps handleSelectApp Error: ' + error);
			});
	}
	render() {
		return (
			<div>
				<Header
					createNewApp={this.createNewApp.bind(this)} />
				<div className="columns">
					<LeftSide
						serversList={this.getServers}
					    onChange={this.onChange}
						selected={this.state.selected}
						results={this.state.results}
						orgs={this.state.orgs}
						app={this.state.app}
						handleSelectApp={this.handleSelectApp} />
					<RightSide
						app={this.state.app}
						createNewApp={this.state.newApp}
						falseNewApp={this.setFalseNewApp.bind(this)}
					    orgs={this.state.orgs} />
				</div>
			</div>
		);
	};
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/components/dashboard.js